// Formats the `ipHistoryCoverageStartsAt` field for the IP History coverage copy.
//
// Deliberately string-based: `new Date('2026-09-10')` parses as UTC midnight, so
// formatting it in local time renders 2026-09-09 for anyone behind UTC. This never
// constructs a Date, so the rendered day cannot shift.
//
// The backend currently sends a bare YYYY-MM-DD, but the leading anchor also accepts
// a full ISO 8601 timestamp and ignores the time component, so a change to that form
// does not shift the rendered day either.
//
// Returns null for an absent or malformed value. Callers render the sentence WITHOUT
// a date in that case, and must never substitute a hardcoded fallback date: that would
// recreate the cross-repo drift this field exists to prevent.
export const formatCoverageDate = (raw?: string): string | null => {
  if (!raw) return null;

  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw.trim());
  if (!match) return null;

  return `${match[1]}-${match[2]}-${match[3]}`;
};
